module.exports = __webpack_public_path__ + "static/media/correct.764f99b1.mp3";